import { Box, Container, Step, StepLabel, Stepper, useMediaQuery, useTheme } from '@mui/material';
import type { ReactNode } from 'react';
import { SCRIPTPAD_LOGO_URL, colors } from '@scriptpad/shared';

interface WizardLayoutProps {
  visualStep: number;
  children: ReactNode;
}

const STEPS = ['Welcome', 'Practice', 'Verify Practice', 'HPI-I', 'Identity', 'Done'];

export const WizardLayout = ({ visualStep, children }: WizardLayoutProps) => {
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: `radial-gradient(circle at top, ${colors.bgWash} 0%, #ffffff 60%)`,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box sx={{ px: { xs: 3, sm: 6 }, pt: { xs: 3, sm: 4 } }}>
        <Box
          component="img"
          src={SCRIPTPAD_LOGO_URL}
          alt="ScriptPad"
          sx={{ height: 36, display: 'block' }}
        />
      </Box>

      <Container
        maxWidth="md"
        disableGutters={isSm}
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          py: { xs: 3, sm: 6 },
        }}
      >
        <Stepper
          activeStep={visualStep - 1}
          alternativeLabel={!isSm}
          orientation="horizontal"
          sx={{ mb: { xs: 3, sm: 6 }, px: { xs: 1, sm: 0 } }}
        >
          {STEPS.map((label) => (
            <Step key={label}>
              <StepLabel>{!isSm ? label : ''}</StepLabel>
            </Step>
          ))}
        </Stepper>

        <Box sx={{ flex: 1, display: 'flex', alignItems: 'flex-start', justifyContent: 'center' }}>
          <Box sx={{ width: '100%', maxWidth: 720 }}>{children}</Box>
        </Box>
      </Container>

      <Box
        component="footer"
        sx={{
          textAlign: 'center',
          py: 3,
          color: colors.lightGrey,
          fontSize: 13,
          fontFamily: '"Open Sans", sans-serif',
        }}
      >
        ScriptPad Pty Ltd ACN 620 784 714 &middot; <a href="https://scriptpad.health" style={{ color: colors.lightGrey }}>scriptpad.health</a>
      </Box>
    </Box>
  );
};
